//componente layout pour le qrcodeimport { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Component, effect, inject, OnInit, signal, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { filter, startWith, Subscription } from 'rxjs';
import { ILanguage } from '@app/common-codes/_models/ILanguageDedinition';
import { MatwinsVariablesService } from '@app/common-codes/services/matwinsVariables.service';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { NavigationService } from '@app/common-codes/services/navigation.service';
import { Tenant } from '@app/common-codes/models/matwins-tenant/Tenant.model';
import { DependencyInjectionProvider } from '@app/common-codes/services/DependecyInjection.provider';
import { DataService } from '@app/common-codes/services/DataService';
import { CurrentTenantService } from '@app/common-codes/services/CurrentTenantService';
import { LoaderService } from '@app/common-codes/services/loader.service';
import { PointOfService } from '@app/common-codes/models/matwins-tenant/PointOfService.model';
import { AuthentificationService } from '@app/common-codes/services/authentification.service';
import { AlertModalService, ToastType } from '@app/common-codes/services/AlertModalService';

@Component({
    selector: 'app-ipad-layout',
    templateUrl: './ipad-layout.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RouterModule,
        CommonModule,
        TranslatePipe
    ]
})
export class IpadLayoutComponent implements OnInit {
    // Ce layout ne nécessite pas d'authentification
    // C'est un layout simple qui permet d'afficher le contenu des composants enfants
    // via le router-outlet
    isLoading = false;

    currentTime = new Date()
    currentLanguage = 'en';
    private firstCallTranslation = false;

    private langSubscription: Subscription = new Subscription();
    langMenuOpen = false;
    languages: ILanguage[] | undefined = [];

    routerSub: Subscription = new Subscription();
    router = inject(Router);

    tenantService: DataService<Tenant>;
    pointOfServiceService: DataService<PointOfService>;

    private matwinsArgsLoaded = signal<boolean>(false);
    private languageLoaded = false;

    showPinModal = false;
    pinValue = '';
    private readonly CORRECT_PIN = '1357';
    private inactivityTimer: any;

    private idleTimer: any;
    private readonly IDLE_TIMEOUT = 30000;
    private idleListeners: { event: string; handler: EventListener }[] = [];



    constructor(public translationService: TranslationService,
        private activatedroute: ActivatedRoute,
        private matwinsVariablesService: MatwinsVariablesService,
        public navService: NavigationService,
        private di: DependencyInjectionProvider,
        public currentTenantService: CurrentTenantService,
        public loaderService: LoaderService,
        public authentificationService: AuthentificationService,
        private alertModalService: AlertModalService,
    ) {

        // Avant signin() : les premieres requetes doivent deja porter l'identite du client.
        this.resolveClientFromUrlOrStorage();

        authentificationService.signin();
        effect(() => {
            const accessToken = this.matwinsVariablesService.accessTokenChanged$();
            if (!this.firstCallTranslation && accessToken != null && accessToken != '') {
                this.firstCallTranslation = true;
                // this.translationService.initializeLanguage();
            }
        });

        this.tenantService = this.di.getOrCreateDataService(Tenant);
        this.pointOfServiceService = this.di.getOrCreateDataService(PointOfService);

        effect(() => {
            let loaded = this.matwinsArgsLoaded();
            if (loaded) {
                const path = this.router.url;

                // const currentRoute = `/qrcode/${this.variables.clientId}/${this.variables.posId}/home`;
                this.navService.initializeWith(path);
                // this.translationService.initializeLanguage();

            }

        });

        effect(async () => {
            const verified = this.authentificationService.userVerified();
            if (!verified) return;
            if (!this.matwinsArgsLoaded()) {
                if (!this.currentTenantService.currentTenant()
                    || !this.currentTenantService.currentPointOfService()) {
                    if (this.matwinsVariablesService.clientId && this.matwinsVariablesService.posId) {
                        var tenant = await this.tenantService.execute<Tenant>('GET', 'getByClientId', {
                            clientId: this.matwinsVariablesService.clientId,
                            posId: this.matwinsVariablesService.posId
                        });
                        this.currentTenantService.currentTenant.set(tenant);
                        this.currentTenantService.currentClientId.set(this.matwinsVariablesService.clientId);
                        this.matwinsArgsLoaded.set(true);
                        const pos = await this.pointOfServiceService.get(this.matwinsVariablesService.posId!);
                        this.currentTenantService.currentPointOfService.set(pos);
                        this.currentTenantService.currentPointOfServiceId.set(this.matwinsVariablesService.posId);
                    } else {
                        var tenant = await this.tenantService.execute<Tenant>('GET', 'getAvailablePos');
                        this.currentTenantService.currentTenant.set(tenant);
                        this.currentTenantService.currentClientId.set(tenant?.managerClient || '');
                        this.matwinsVariablesService.clientId = tenant?.managerClient || '';
                        if (tenant?.pointOfServices && tenant.pointOfServices.length > 1) {
                            this.router.navigate(['/ipad-pos-choice']);
                        } else if (tenant?.pointOfServices && tenant.pointOfServices.length === 1) {
                            this.currentTenantService.currentPointOfService.set(tenant.pointOfServices[0]);
                            this.currentTenantService.currentPointOfServiceId.set(tenant.pointOfServices[0].id);
                            this.matwinsVariablesService.posId = tenant.pointOfServices[0].id;
                            this.matwinsArgsLoaded.set(true);
                        } else {
                            // Aucun POS : erreur affichée dans le périmètre kiosque (jamais /unauthorized).
                            this.router.navigate(['error'], { relativeTo: this.activatedroute });
                        }
                    }
                }
            }
        });
    }

    /** L'URL prime (liens du Test-Hub) ; le stockage local sert de repli au kiosque. */
    private resolveClientFromUrlOrStorage(): void {
        const vars = this.matwinsVariablesService;
        if (vars.clientId && vars.posId) return;

        const params = this.activatedroute.snapshot.paramMap;
        const paramPosId = params.has('pos') ? parseInt(params.get('pos') || '0') : null;
        if (params.get('tenant') && paramPosId) {
            vars.clientId = params.get('tenant');
            vars.posId = paramPosId;
            return;
        }

        const storedClientId = localStorage.getItem('ipad-client-id');
        const storedPosId = localStorage.getItem('ipad-pos-id');
        if (storedClientId && storedPosId) {
            vars.clientId = storedClientId;
            vars.posId = parseInt(storedPosId, 10);
        }
    }

    ngOnInit(): void {
        this.translationService.managedLanguages$.subscribe(languages => {
            if (languages && languages.length > 0 && !this.languageLoaded) {
                this.languages = languages;
                this.languageLoaded = true;
            }
        });

        // S'abonner aux changements de langue
        this.langSubscription = this.translationService.currentLanguage$.subscribe(lang => {
            this.currentLanguage = lang;
        });
        setInterval(() => {
            this.currentTime = new Date();
        }, 1000);

        this.setupIdleTimer();

    }

    ngOnDestroy() {
        this.langSubscription.unsubscribe();
        this.clearIdleTimer();
        this.removeIdleListeners();
    }

    // --- Timer d'inactivité global (30s) ---
    private setupIdleTimer() {
        const events = ['touchstart', 'click', 'mousemove', 'keydown'];
        this.idleListeners = events.map(event => {
            const handler = () => this.resetIdleTimer();
            window.addEventListener(event, handler);
            return { event, handler };
        });
        this.resetIdleTimer();
    }

    private resetIdleTimer() {
        this.clearIdleTimer();
        this.idleTimer = setTimeout(() => {
            if (this.router.url !== '/ipad/home') {
                this.navService.navigateTo('/ipad/home');
            }
        }, this.IDLE_TIMEOUT);
    }

    private clearIdleTimer() {
        if (this.idleTimer) {
            clearTimeout(this.idleTimer);
            this.idleTimer = null;
        }
    }

    private removeIdleListeners() {
        this.idleListeners.forEach(({ event, handler }) => {
            window.removeEventListener(event, handler);
        });
        this.idleListeners = [];
    }
    // ----------------------------------------



    openPinModal() {
        this.showPinModal = true;
        this.pinValue = '';
        this.startInactivityTimer();
    }

    closePinModal() {
        this.showPinModal = false;
        this.pinValue = '';
        this.clearInactivityTimer();
    }

    private startInactivityTimer() {
        this.clearInactivityTimer();
        this.inactivityTimer = setTimeout(() => {
            this.closePinModal();
        }, 7000);
    }

    private clearInactivityTimer() {
        if (this.inactivityTimer) {
            clearTimeout(this.inactivityTimer);
            this.inactivityTimer = null;
        }
    }

    getPinMask(): string {
        return '•'.repeat(this.pinValue.length);
    }

    addDigit(digit: string) {
        if (this.pinValue.length < 4) {
            this.pinValue += digit;
            this.startInactivityTimer();
            if (this.pinValue.length === 4) {
                this.submitPin();
            }
        }
    }

    removeDigit() {
        this.pinValue = this.pinValue.slice(0, -1);
        this.startInactivityTimer();
    }

    submitPin() {
        this.clearInactivityTimer();
        if (this.pinValue === this.CORRECT_PIN) {
            localStorage.removeItem('ipad-client-id');
            localStorage.removeItem('ipad-pos-id');
            this.closePinModal();
            // Logout complet (session IdP incluse) : au retour sur l'app, l'AuthGuard
            // déclenche le flow OIDC vers la page de login, comme la vue admin.
            // logoutLocal() laissait la session IdP active : le kiosque se
            // ré-authentifiait silencieusement et restait sur /ipad/home.
            this.authentificationService.logout();
        } else {
            this.alertModalService.showToast('Wrong Code', ToastType.Error, 3000);
            this.pinValue = '';
            this.closePinModal();
        }
    }

    /** La page d'erreur kiosque s'affiche même sans POS ni compte vérifié. */
    get isErrorPage(): boolean {
        return this.router.url.includes('/error');
    }

    goBack() {
        this.navService.goBack();
    }

    canGoBack(): boolean {
        return this.navService.canGoBackAny();
    }

    toggleLangMenu() {
        this.langMenuOpen = !this.langMenuOpen;
    }

    closeLangMenu() {
        this.langMenuOpen = false;
    }

    async changeLanguage(languageKey: string) {
        this.langMenuOpen = false;
        this.isLoading = true;

        try {
            await this.translationService.use(languageKey);
        } catch (error) {
            console.error('Erreur lors du changement de langue:', error);
        } finally {
            this.isLoading = false;
        }
    }

    // obtenir le nom de la langue courante
    getCurrentLanguageName(): string {
        const currentLang = this.languages?.find(lang => lang.key === this.currentLanguage);
        return currentLang ? currentLang.name : this.currentLanguage;
    }

    // obtenir l'emoji du drapeau (fallback si le logo n'est pas encore charge)
    getFlagEmoji(languageKey: string): string {
        const flagMap: { [key: string]: string } = {
            'en': '🇬🇧',
            'en-us': '🇺🇸',
            'en-ca': '🇨🇦',
            'fr': '🇫🇷',
            'fr-ca': '🇨🇦',
            'es': '🇪🇸'
        };
        return flagMap[languageKey] || '🌐';
    }
}
